import { render, staticRenderFns } from "./SideModal.vue?vue&type=template&id=084adc8c&"
import script from "./SideModal.vue?vue&type=script&lang=js&"
export * from "./SideModal.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/components/side-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports